module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-114.53ae21c6.svg";